export enum TableHeader {
    titleForUserTable = 'Korisnik',
}

export enum TableColumns {
    name= 'Naziv',
    firstandlastname= 'Ime i prezime',
    enterprisename= 'Naziv firme/gazdinstva',
    email= 'E-mail',
    address= 'Adresa',
    phone= 'Telefon',
    active= 'Status',
    activateDeactivate= 'Aktivacija / Deaktivacija',
    edit= 'Izmena',
    delete= 'Brisanje',
    enterprise= 'Firma',
}

export enum TableMessages {
    activate= 'Korisnik je uspešno aktiviran!',
    deactivate= 'Korisnik je uspešno deaktiviran!',
}

export enum ModalForAddOrUpdateUser {
    titleForAddUser = 'Dodavanje novog korisnika',
    titleForUpdateUser = 'Izmena podataka o korisniku',
    saveSuccessMessage = 'Novi korisnik je uspešno sačuvan.',
    updateSuccessMessage = 'Podaci o korisniku su uspešno izmenjeni.',
}

export enum Placeholders {
    firstname = 'Ime',
    lastname = 'Prezime',
    username = 'Korisničko ime',
    password = 'Lozinka',
    confirmPassword = 'Ponovljena lozinka',
    email = 'E-mail',
    phone = 'Broj telefona',
    pib = 'PIB',
    registrationnumber = 'Matični broj',
    address = 'Adresa',
    name = 'Naziv',
    role = 'Rola korisnika *',
    enterprisename = 'Naziv firme/gazdinstva',
}

export enum Errors {
    emailEmpty = 'Morate uneti E-mail adresu!',
    usernameEmpty = 'Korisničko ime ne može biti prazno!',
    passwordEmpty = 'Morate uneti lozinku!',
    confirmPasswordEmpty = 'Morate uneti ponovljenu lozinku!',
    firstnameEmpty = 'Morate uneti ime!',
    lastnameEmpty = 'Morate uneti prezime!',
    nameEmpty = 'Morate uneti naziv!',
    pibEmpty = 'Morate uneti PIB!',
    registrationNumberEmpty = 'Morate uneti matični broj!',
    passwordsDontMatch = 'Lozinka i ponovljena lozinka se razlikuju!',
}

export enum ConfirmDialog {
    deactivateUserMessage= 'deaktivirate izabranog korisnika',
    activateUserMessage= 'aktivirate izabranog korisnika',
    deactivate= ', deaktiviraj!',
    activate= ', aktiviraj!',
}

export enum Tooltips {
    activate= 'Aktiviraj korisnika',
    deactivate= 'Deaktiviraj korisnika',
    deactivate2faMessage= 'deaktivirate dvofaktorsku autentikaciju za izabranog korisnika',
    deactivate2faButton= ', deaktiviraj!',
}
